(() => {
  'use strict';
  const initialized = new WeakSet();
  const initialize = root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const dialog = root.querySelector('[data-qrfl-dialog]');
    let opener;
    root.addEventListener('click', event => {
      const preview = event.target.closest('[data-qrfl-preview]');
      if (preview && root.contains(preview) && dialog && typeof dialog.showModal === 'function') {
        opener = preview;
        const title = preview.dataset.qrflTitle || '';
        const image = dialog.querySelector('[data-qrfl-dialog-image]');
        image.src = preview.dataset.qrflImage;
        image.alt = title;
        image.removeAttribute('width');
        image.removeAttribute('height');
        dialog.querySelector('[data-qrfl-dialog-title]').textContent = title;
        dialog.querySelector('[data-qrfl-dialog-caption]').textContent = preview.dataset.qrflCaption || '';
        dialog.showModal();
        dialog.querySelector('[data-qrfl-dialog-close]').focus({preventScroll: true});
      }
      if (event.target.closest('[data-qrfl-dialog-close]') && dialog?.open) dialog.close();
    });
    dialog?.addEventListener('close', () => { if (opener?.isConnected) opener.focus({preventScroll: true}); });
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    const sample = root.querySelector('[data-qrfl-sample]');
    if (!sample) return;
    const guesses = [...sample.querySelectorAll('input[type="radio"]')];
    const reveal = sample.querySelector('[data-qrfl-reveal]');
    const reset = sample.querySelector('[data-qrfl-reset]');
    const status = sample.querySelector('[data-qrfl-status]');
    const slots = [...sample.querySelectorAll('[data-qrfl-answer]')];
    let selected = '';
    guesses.forEach(input => input.addEventListener('change', () => {
      selected = input.value;
      reveal.disabled = false;
      status.textContent = `Your team's guess is ${selected}. Reveal the answers when you are ready.`;
    }));
    reveal.addEventListener('click', () => {
      if (!selected) return;
      slots.forEach(slot => {
        slot.querySelector('[data-qrfl-hidden]').hidden = true;
        slot.querySelector('[data-qrfl-shown]').hidden = false;
        slot.toggleAttribute('data-selected', slot.dataset.qrflAnswer === selected);
      });
      guesses.forEach(input => { input.disabled = true; });
      reveal.hidden = true;
      reset.hidden = false;
      const points = {'K.I.T.T.': 3, 'Batmobile': 2, 'Herbie the Love Bug': 1}[selected] || 0;
      status.textContent = `You picked ${selected}, worth ${points} ${points === 1 ? 'point' : 'points'}. Kit 1 answers: K.I.T.T., 3 points; Batmobile, 2 points; Herbie the Love Bug, 1 point.`;
      reset.focus({preventScroll: true});
    });
    reset.addEventListener('click', () => {
      selected = '';
      slots.forEach(slot => {
        slot.querySelector('[data-qrfl-hidden]').hidden = false;
        slot.querySelector('[data-qrfl-shown]').hidden = true;
        slot.removeAttribute('data-selected');
      });
      guesses.forEach(input => { input.disabled = false; input.checked = false; });
      reset.hidden = true;
      reveal.hidden = false;
      reveal.disabled = true;
      status.textContent = 'Sample reset. Choose another guess to reveal the answers again.';
      guesses[0].focus({preventScroll: true});
    });
  };
  const discover = () => document.querySelectorAll('[data-qrfl-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, {once: true});
  else discover();
  document.addEventListener('shopify:section:load', discover);
})();
